import Button from '@/components/Button';
import { cn } from '@/utils';

function Card({ children, buttons = [] }) {
	return (
		<div className="flex w-full flex-col items-start justify-start rounded border border-grey-200 lg:min-h-[180px]">
			<div
				className={cn(
					'flex w-full flex-grow flex-col gap-2 px-6 py-7',
					buttons.length > 0 && 'border-b border-grey-200'
				)}
			>
				{children}
			</div>

			{buttons.length > 0 && (
				<div className="flex min-h-[60px] flex-wrap gap-2 px-6 py-4">
					{buttons.map(
						({ variant, size, text, action, visible = true }, index) => {
							return (
								visible && (
									<Button
										key={`card-button-${text}-${index}`}
										variant={variant}
										size={size}
										onClick={action}
									>
										{text}
									</Button>
								)
							);
						}
					)}
				</div>
			)}
		</div>
	);
}

export default Card;
